import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import BulletinButton from "../../Assets/Images/bulletinBoard/bulletinButton.png";
import Language from "../../Components/languageComponent/language";

//nav position
const navSerojaCyclonePos ={landscape: 7600, portrait: 9500};

class Bulletin extends Component {
    constructor(props) {
        super(props);
        this.state = {bulletin: false};
        this.onBulletinButtonClicked = this.onBulletinButtonClicked.bind(this);
    }
    render() {
        return (
            <div className="bulletin">
                <div onClick={this.onBulletinButtonClicked}><img src={BulletinButton} alt="bulletinButton" style={{width: '13px', height: '200px'}}/></div>
                <div className="bulletin-board" style={{right: this.state.bulletin == true ? '18px':'-300px'}}>
                    <div className="board-title">
                        <div style={{color:"#FFFF33", fontWeight:'bold', margin:'3px'}}>*</div>
                        <Language language={this.props.language} section="navOngoing"/>
                        <div style={{color:"#FFFF33", fontWeight:'bold', margin:'3px'}}>*</div>
                    </div>
                    <div className="board-content"  onClick={() => this.onNavigateToSection(navSerojaCyclonePos[this.props.orientation])}>
                        <Link to="/Ministries"><Language language={this.props.language} section="bulletinSerojaCyclone"/></Link>
                    </div>
                    <div className="line-separator"/>
                </div>
            </div>
        );
    }
    onBulletinButtonClicked() {
        this.setState({
            bulletin: !this.state.bulletin
        });
    }
    onNavigateToSection = (e) => {
        this.setState({ bulletin: false});
        this.props.updateScrollPos(e);
    }
}
export default Bulletin;